import { Injectable, Inject } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/Rx";
import { List } from "immutable";
import { Spot, Guide, Category } from "../core/model";
import { WindowService } from "./window.service";

@Injectable()
export class GuideService {

    private guideId: String;

    constructor(private http: Http, @Inject(WindowService) private _window: Window) {
        this.guideId = "cmap_bamberg";//_window.guideId;
    }

    getActiveGuide(): Promise<Guide> {
        return new Promise((resolve, reject) => {
            this.loadJsonFromFile("assets/guides/" + this.guideId + "/guide.json").then(json => {
                let guide = this.extractGuide(json);
                resolve(guide);
            }).catch(error => reject(error));
        });
    }

    getCategories(): Promise<Array<Category>> {
        return new Promise((resolve, reject) => {
            this.getActiveGuide().then(guide =>
                resolve(guide.categories)
            ).catch(error => reject(error));
        });
    }

    private loadJsonFromFile(filename): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(filename).forEach(value => {
                let json = value.json();
                resolve(json);
            });
        });
    }


    private extractGuide(json): Guide {

        let guide: Guide = {} as Guide;
        guide._id = json.meta[0].id;
        guide.title = json.meta[0].title;
        guide.subtitle = json.meta[0].subtitle;
        guide.mapcenter = json.meta[0].mapcenter;
        guide.map_server = json.meta[0].map_server;
        guide.map_attribution = json.meta[0].map_attribution;
        let categories = this.extractCategories(json);
        guide.categories = Object.keys(categories).map(function(key) {
            return categories[key];
        });

        let spots = new Array();
        json.spots.forEach(spotJson => {
            let spot: Spot = {} as Spot;
            spot._id = spotJson._id;
            spot.name = spotJson.name;
            spot.description = spotJson.description;
            if (spotJson.geolocation != undefined) {
                let latlng = [spotJson.geolocation.split(",")[1], spotJson.geolocation.split(",")[0]];
                spot.geolocation = {
                    "type": "Feature",
                    "properties": {},
                    "geometry": {
                        "type": "Point",
                        "coordinates": latlng
                    }
                };
                spot.category = categories[spotJson.category];
                spots.push(spot);
            }
        });
        guide.spots = spots;
        return guide;
    }

    private extractCategories(json) {
        let categories = {};
        json.categories.forEach(categoryJson => {
            let category: Category = this.extractCategory(categoryJson);
            categories[categoryJson.name] = category;
        });
        return categories;
    }

    private extractCategory(categoryJson) {
        let category: Category = {} as Category;
        category.name = categoryJson.name;
        category.markerUrl = categoryJson.markerurl;
        category.color = categoryJson.color;
        category.icon = categoryJson.icon;
        return category;
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || {};
    }

}



// WEBPACK FOOTER //
// ./src/app/services/guide.service.ts